import Skeleton from "@mui/material/Skeleton";
import DataGridNewCard from "designSystem/components/dataGrid/DatGridNewCard";
import { Box, DataGrid, DataGridCardProps, GalleryPlaceholder, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import WorkingCache from "csi/state/WorkingCache";
import { C8Node, cnl, IDataStore } from "csi/typings";
import xml from "csi/xml";
import React from "react";

const Card = (props: DataGridCardProps<C8Node>) => {
	const { item } = props;

	return (
		<Box
			bgcolor="background.paper"
			border={STANDARD_BORDER_STYLE}
			height={1}
			p={2}
		>
			<Box height={100}>
				<Text text={item.$Name} variant="subtitle1" />
			</Box>
		</Box>
	);
};

const SkeletonCard = () => {
	return (
		<Box
			bgcolor="background.paper"
			border={STANDARD_BORDER_STYLE}
			height={1}
			p={2}
		>
			<Skeleton height={100} variant="rectangular" />
		</Box>
	);
};

const NewComponent = () => {
	return (
		<DataGridNewCard
			minHeight={100}
			nodeType="Item"
			onClick={() => console.log("Clicked new item")}
		/>
	);
};

const PlaceholderComponent = () => {
	return (
		<GalleryPlaceholder titleProps={{ text: "No Data" }} />
	);
};

class MockNodeDataStore implements IDataStore<C8Node> {
	private readonly cache: WorkingCache;
	private readonly urls: cnl[];
	readonly total: number;

	getIdentity = (item: C8Node) => item.$URL;
	getIdentityIndex = (id: string): number | undefined => 0;
	getNextIdentity = (id: string, previous?: boolean, defaultToFirst?: boolean): string | undefined => id;
	get = (index: number): C8Node => this.cache.get(this.urls[index]);
	load = (start: number, end: number): Promise<number> => {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve(this.urls.length);
			}, 2000);
		});
	};
	move = (from: number, to: number) => { };
	remove = (id: string) => { };

	constructor(urls: cnl[], cache: WorkingCache) {
		this.urls = urls;
		this.cache = cache;
		this.total = urls.length;
	}
}

const cache = new WorkingCache();
const urls: cnl[] = [];

for (let i = 0; i < 200; ++i) {
	const node = xml.nodeCreateClientNode(null, "X", `Node ${i + 1}`);
	cache.add(node);
	urls.push(node.$URL);
}

const store = new MockNodeDataStore(urls, cache);

export default () => {
	return (
		<DataGrid
			CardComponent={Card}
			NewCardComponent={NewComponent}
			PlaceholderComponent={PlaceholderComponent}
			SkeletonComponent={SkeletonCard}
			columnsByWidth={[
				[2, 1],
				[3, 750],
				[4, 1000],
				[6, 1500],
			]}
			store={store}
		/>
	);
};